import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

const primaryColors = {
    background: NebraskaColors.elementPrimary,
    content: NebraskaColors.basePrimary,
    alphas: {
        default: 1,
        hover: 0.9,
        active: 0.8
    }
};
const secondaryColors = {
    background: NebraskaColors.themePrimary,
    content: NebraskaColors.themePrimary,
    alphas: {
        default: 0,
        hover: 0.08,
        active: 0.16
    }
};
const buttonSecondaryColors = {
    background: NebraskaColors.themePrimary,
    content: NebraskaColors.elementPrimary,
    alphas: {
        default: 0,
        hover: 0.08,
        active: 0.16
    }
};
const tertiaryColors = {
    background: 'transparent',
    content: NebraskaColors.elementPrimary,
    alphas: {
        default: 1,
        hover: 1,
        active: 1
    }
};
const overPrimary = {
    background: NebraskaColors.themeOverPrimary,
    content: NebraskaColors.themeOverPrimary,
    alphas: {
        default: 0,
        hover: 0.32,
        active: 0.4
    }
};
({
    background: NebraskaColors.staticWhite,
    content: NebraskaColors.staticWhite,
    alphas: {
        default: 0,
        hover: 0.32,
        active: 0.4
    }
});
const primaryOverImage = {
    background: NebraskaColors.elementOverImage,
    content: NebraskaColors.staticBlack,
    alphas: {
        default: 1,
        hover: 0.9,
        active: 0.8
    }
};
const secondaryOverImage = {
    background: NebraskaColors.elementOverImage,
    content: NebraskaColors.elementOverImage,
    alphas: {
        default: 0,
        hover: 0.08,
        active: 0.08
    }
};
const tertiaryOverImage = {
    background: 'transparent',
    content: NebraskaColors.elementOverImage,
    alphas: {
        default: 1,
        hover: 1,
        active: 1
    }
};
const buttonBoxColors = {
    background: NebraskaColors.basePrimaryDarken,
    content: NebraskaColors.elementPrimary,
    alphas: {
        default: 0,
        hover: 1,
        active: 1
    }
};
const contextualColors = {
    background: NebraskaColors.backgroundHover,
    content: 'currentColor',
    alphas: {
        default: 0,
        hover: 1,
        active: 1
    }
};
const contextualOverImage = {
    background: NebraskaColors.backgroundHover,
    content: NebraskaColors.elementOverImage,
    alphas: {
        default: 0,
        hover: 1,
        active: 1
    }
};

export { buttonBoxColors, buttonSecondaryColors, contextualColors, contextualOverImage, overPrimary, primaryColors, primaryOverImage, secondaryColors, secondaryOverImage, tertiaryColors, tertiaryOverImage };
//# sourceMappingURL=Button.js.map
